(function(){
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function pushEvent(name, payload){
    try {
      var data = payload || {};
      data.event = name;
      data.page_path = window.location.pathname;
      data.page_title = document.title;
      window.dataLayer.push(data);
    } catch(e) {}
  }

  function initReveal(){
    var els = document.querySelectorAll('.ae-reveal');
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function(el){ io.observe(el); });
  }

  function initConversionTracking(){
    document.addEventListener('click', function(e){
      var link = e.target.closest('a[href^="tel:"], a[href*="wa.me"], a[href*="whatsapp"], [data-ae-conversion]');
      if(!link) return;
      var href = link.getAttribute('href') || '';
      var label = (link.innerText || link.getAttribute('aria-label') || '').trim().slice(0,120);
      var source = link.getAttribute('data-ae-conversion') || 'theme_link';

      if(href.indexOf('tel:') === 0){
        pushEvent('click_call', {link_url:href, link_text:label, source:source});
      } else if(href.indexOf('wa.me') !== -1 || href.indexOf('whatsapp') !== -1){
        pushEvent('click_whatsapp', {link_url:href, link_text:label, source:source});
      } else if(source){
        pushEvent('click_cta', {link_url:href, link_text:label, source:source});
      }
    }, true);

    document.addEventListener('submit', function(e){
      var form = e.target;
      if(!form) return;
      var action = (form.getAttribute('action') || '').toLowerCase();
      if(action.indexOf('/contact') !== -1 || form.querySelector('[name^="contact"]')){
        pushEvent('lead_form_submit', {form_action: action || '/contact', source:'theme_contact_form'});
      }
    }, true);

    if(document.querySelector('.ae-top-conversion')){
      pushEvent('ae_top_conversion_bar_loaded', {source:'top_conversion_bar'});
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initReveal(); initConversionTracking(); });
  } else {
    initReveal();
    initConversionTracking();
  }
})();
